var _path, _g, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _g5, _g6, _path10, _g7, _g8, _path11, _path12, _g9, _path13, _path14, _path15, _g10, _path16, _path17, _path18, _g11, _g12, _path19, _path20, _path21, _g13, _g14, _path22, _path23, _path24, _g15, _g16, _path25, _path26, _path27, _g17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttackBoxmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "15 0 205 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A3EA2A",
    d: "M68.987 41.844c1.791 0 1.791-2.79 0-2.79-1.792 0-1.792 2.79 0 2.79ZM194.849 57.653c1.792 0 1.792-2.791 0-2.791-1.791 0-1.791 2.791 0 2.791ZM44.483 76.261c1.79 0 1.79-2.79 0-2.79-1.792 0-1.792 2.79 0 2.79ZM201.839 88.812c.9 0 .9-1.396 0-1.396-.901 0-.901 1.396 0 1.396ZM34.764 99.048c.9 0 .9-1.396 0-1.396s-.9 1.396 0 1.396ZM35.655 49.957c.9 0 .9-1.395 0-1.395s-.9 1.395 0 1.395ZM168.386 109.506c.901 0 .901-1.396 0-1.396-.9 0-.9 1.396 0 1.396ZM117.225 38.67c.9 0 .9-1.396 0-1.396-.901 0-.901 1.396 0 1.396ZM117.225 95.129c.9 0 .9-1.396 0-1.396-.901 0-.901 1.396 0 1.396ZM79.41 82.775c1.792 0 1.792-2.79 0-2.79-1.791 0-1.791 2.79 0 2.79Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M220.254 35.75v4.214l-3.323 2.373-3.323-2.894v3.843h-3.147l-.779.79-2.627-.623s1.856 1.74 2.163 2.205c.306.466 2.255 2.336 2.255 2.336h3.769l4.371 3.722-4.511-3.452-4.297.428s-3.685-4.094-4.817-4.43l-.882-2.046 3.443.52 1.402-1.283 2.255.428 1.003-5.071 2.525 2.624-1.216-2.475-2.042-1.22s-1.643.913-1.857.913c-.213 0-3.165-.363-3.165-.363l-4.325 1.86-3.964-2.688-3.443.307-3.899 1.768-4.854-2.075-1.754 3.172-1.123.242-.214-.67 2.376-5.247 5.207 2.596 2.952-2.075 5.328.065 3.416 2.075 5.021-1.126 2.831.186 2.228-.698 2.441 1.284 1.336 3.117 3.231-2.624.009-.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EB0037",
    strokeMiterlimit: 10,
    strokeWidth: 0.01,
    d: "M220.254 35.75v4.214l-3.323 2.373-3.323-2.894v3.843h-3.147l-.779.79-2.627-.623s1.856 1.74 2.163 2.205c.306.466 2.255 2.336 2.255 2.336h3.769l4.371 3.722-4.511-3.452-4.297.428s-3.685-4.094-4.817-4.43l-.882-2.046 3.443.52 1.402-1.283 2.255.428 1.003-5.071 2.525 2.624-1.216-2.475-2.042-1.22s-1.643.913-1.857.913c-.213 0-3.165-.363-3.165-.363l-4.325 1.86-3.964-2.688-3.443.307-3.899 1.768-4.854-2.075-1.754 3.172-1.123.242-.214-.67 2.376-5.247 5.207 2.596 2.952-2.075 5.328.065 3.416 2.075 5.021-1.126 2.831.186 2.228-.698 2.441 1.284 1.336 3.117 3.231-2.624.009-.009Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.01,
    d: "M219.474 33.851v4.54l-3.323 2.374-3.323-2.894v3.843h-3.146l-.78.79-2.627-.623s1.856 1.74 2.163 2.205c.306.465 2.255 2.336 2.255 2.336h3.63l4.492 3.824-4.632-3.545-4.409.437s-3.787-4.206-4.947-4.55l-.909-2.103 3.536.53 1.439-1.32 2.311.437 1.03-5.201 2.599 2.698-1.253-2.54-2.098-1.256s-1.689.94-1.903.94c-.213 0-3.257-.373-3.257-.373l-4.446 1.917-4.066-2.763-3.536.316-4.001 1.814-4.984-2.13-1.801 3.265-1.16.252-.223-.689 2.441-5.396 5.347 2.66 3.035-2.13 5.476.065 3.499 2.13 5.161-1.162 2.905.186 2.284-.726 2.506 1.321 1.373 3.201 3.314-2.698.028.018Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m202.265 34.67-3.239-5.49h-4.186l-4.437-2.252-2.794-2.373 2.896 2.27 4.428 2.746 4.344-.056 3.035 5.154h-.047ZM195.981 25.412l.557-1.489-.733-1.228.529-3.49-.158 3.49.771 1.228-.706 1.629-.26-.14Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m202.265 34.67-3.239-5.49h-4.186l-4.437-2.252-2.794-2.373 2.896 2.27 4.428 2.746 4.344-.056 3.035 5.154h-.047Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m195.053 27.273.557-1.489-.733-1.228.529-3.49-.158 3.49.771 1.228-.706 1.629-.26-.14Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M126.107 89.194h-18.935v15.315h18.935V89.193Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M170.094 28.593H64.429a1.85 1.85 0 0 0-1.847 1.852v62.136a1.85 1.85 0 0 0 1.847 1.851h105.665a1.85 1.85 0 0 0 1.848-1.852V30.446a1.85 1.85 0 0 0-1.848-1.852Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2538",
    d: "M171.942 30.445v56.944H62.582V30.445c0-1.023.826-1.852 1.847-1.852h105.675c1.021 0 1.847.829 1.847 1.852h-.009Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M129.644 106.751h-25.479a1.309 1.309 0 0 1-1.309-1.312v-1.442h28.106v1.442c0 .726-.585 1.312-1.309 1.312h-.009Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2538",
    d: "M117.475 92.096c1.01 0 1.829-.821 1.829-1.833a1.831 1.831 0 0 0-1.829-1.833 1.83 1.83 0 0 0-1.828 1.833 1.83 1.83 0 0 0 1.828 1.832Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M66.555 82.671V32.864c0-.67.538-1.21 1.206-1.21h99.001c.668 0 1.207.54 1.207 1.21v49.807c0 .912-.771 1.656-1.708 1.656H68.263c-.947 0-1.708-.744-1.708-1.656Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m74.268 59.028-3.286 1.795-.659.773-.065 1.181-2.45-.549-2.172-1.367v1.293l1.077.986 4.566.893.585-2.54 3.24-2.186"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m74.351 55.439-.399-2.373-4.724-.819-.232-2.53-.047 3.014 4.326.586v2.233"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m71.4 57.504-1.791-3.47-3.973 1.153v1.35l3.453-.475 2.097 2.754"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m75.92 57.335-1.986-3.815-4.121-.707-.204-2.205-.037 2.623 3.703.512v2.02l1.708 1.879-.798 1.116-2.915 1.591-.575.68-.056 1.051-2.172-.493-1.912-1.2v1.126l.937.865 4.02.781.51-2.233 2.85-1.916"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m75.994 45.723 3.713-1.033-1.03-1.61 1.754-3.275-2.023-2.242c0-1.628-.77-5.909-.77-5.909l-4.976.298-.882-.595h-3.332l1.643 3.675h2.024l-.548 1.917 1.699 1.59 3.62-.38 1.912 1.758-2.126 3.34.77.884-1.605.55.176 1.032h-.019Zm-2.534-8.04-.742-1.218.742-2.112-3.109-.475-.316-1.274 2.58.595H76.2l.686 4.113-3.425.372Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB0037",
    d: "m76.022 38.095-3.972 2.987v2.791L70.036 46.6l1.707-2.764v-2.921l3.778-2.82h.501Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m71.614 57.43-1.57-3.053-3.49 1.015v1.181l3.036-.409 1.838 2.42M75.994 45.723l3.713-1.033-1.03-1.61 1.754-3.275-2.023-2.242c0-1.628-.77-5.909-.77-5.909l-4.976.298-.882-.595h-3.332l1.643 3.675h2.024l-.548 1.917 1.699 1.59 3.62-.38 1.912 1.758-2.126 3.34.77.884-1.605.55.176 1.032h-.019Zm-2.534-8.04-.742-1.218.742-2.112-3.109-.475-.316-1.274 2.58.595H76.2l.686 4.113-3.425.372Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m76.022 38.093-3.972 2.986v2.792l-2.014 2.726 1.707-2.763v-2.922l3.778-2.82h.501Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.663 78.438v3.294l2.6 1.852 2.598-2.261v3.005h2.46l.612.614 2.052-.484s-1.458 1.359-1.69 1.722c-.232.362-1.763 1.823-1.763 1.823h-2.943l-3.415 2.912 3.518-2.698 3.35.335s2.878-3.2 3.76-3.461l.686-1.6-2.691.409-1.096-1.005-1.763.335-.79-3.964-1.976 2.047.956-1.935 1.596-.958s1.281.716 1.448.716c.167 0 2.478-.288 2.478-.288l3.38 1.451 3.09-2.103 2.692.242 3.044 1.387 3.787-1.62 1.374 2.485.882.195.167-.52-1.857-4.104-4.065 2.028-2.311-1.619-4.168.047-2.664 1.619-3.926-.884-2.209.14-1.736-.55-1.902 1.005-1.05 2.429-2.524-2.047.01.01Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.276 76.958v3.545l2.599 1.852 2.599-2.261v3.005h2.46l.612.614 2.051-.483s-1.457 1.358-1.689 1.72c-.232.364-1.764 1.825-1.764 1.825h-2.84l-3.508 2.986 3.62-2.772 3.443.344s2.961-3.285 3.862-3.555l.705-1.637-2.766.419-1.123-1.033-1.81.344-.808-4.066-2.032 2.103.974-1.982 1.643-.977s1.318.735 1.485.735c.167 0 2.543-.298 2.543-.298l3.472 1.498 3.174-2.158 2.766.242 3.128 1.423 3.89-1.665 1.41 2.55.9.195.168-.54-1.903-4.215L85.36 76.8l-2.367-1.665-4.279.046-2.738 1.666-4.028-.903-2.274.149-1.783-.568-1.958 1.033-1.077 2.503-2.59-2.103h.01Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m75.725 77.592 2.534-4.29h3.268l3.462-1.758 2.19-1.852-2.264 1.778-3.463 2.14-3.397-.037-2.367 4.019h.037Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m84.255 71.813-.436-1.164.576-.958-.418-2.726.13 2.726-.603.958.547 1.275.204-.112Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M172.554 40.773v3.294l-2.599 1.852-2.599-2.261v3.005h-2.46l-.612.614-2.051-.484s1.457 1.359 1.689 1.722c.232.362 1.763 1.823 1.763 1.823h2.943l3.416 2.913-3.518-2.699-3.351.335s-2.877-3.2-3.759-3.461l-.687-1.6 2.692.409 1.095-1.005 1.763.335.789-3.964 1.977 2.047-.956-1.935-1.596-.958s-1.281.716-1.448.716c-.167 0-2.478-.288-2.478-.288l-3.379 1.451-3.091-2.103-2.692.242-3.044 1.387-3.787-1.62-1.374 2.485-.882.195-.167-.52 1.857-4.104 4.065 2.028 2.311-1.619 4.168.047 2.664 1.619 3.926-.884 2.209.14 1.736-.55 1.903 1.005 1.049 2.429 2.524-2.047-.009.01Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M171.942 39.295v3.545l-2.599 1.851-2.599-2.26v3.005h-2.46l-.613.614-2.051-.484s1.457 1.359 1.689 1.721c.232.363 1.764 1.824 1.764 1.824h2.84l3.509 2.987-3.62-2.773-3.444.344s-2.961-3.284-3.861-3.554l-.705-1.638 2.766.42 1.123-1.034 1.81.345.807-4.066 2.033 2.102-.975-1.981-1.643-.977s-1.318.735-1.485.735c-.167 0-2.543-.298-2.543-.298l-3.471 1.498-3.175-2.159-2.766.242-3.128 1.424-3.889-1.666-1.411 2.55-.9.195-.167-.54 1.903-4.214 4.176 2.084 2.367-1.666 4.279.047 2.738 1.665 4.029-.902 2.274.149 1.782-.568 1.958 1.033 1.077 2.503 2.59-2.103h-.009Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m158.501 39.926-2.534-4.29H152.7l-3.471-1.758-2.182-1.852 2.265 1.777 3.453 2.14 3.406-.037 2.358 4.02h-.028Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m149.962 34.147.436-1.163-.566-.958.408-2.727-.12 2.727.603.958-.557 1.275-.204-.112Z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m158.501 39.928-2.534-4.29H152.7l-3.471-1.758-2.182-1.852 2.265 1.777 3.453 2.14 3.406-.037 2.358 4.02h-.028Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m149.962 34.149.436-1.163-.566-.959.408-2.726-.12 2.726.603.959-.557 1.274-.204-.111Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m73.275 53.605 3.119.912.584 2.149 1.792 1.945 1.56 1.107-1.523-1.173-1.773-1.944-.557-2.159-3.23-.94.028.103Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m78.473 58.182.65-.493.705.214 1.643-.736-1.69.55-.714-.233-.706.577.112.12ZM78.26 41.192l2.413-2.187 2.125.633 2.59-.502 1.763-.745-1.8.68-2.58.493-2.126-.661-2.488 2.26.102.029Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m84.859 39.163-.065-.81.547-.493.242-1.795-.427 1.74-.567.483.121.903.149-.028ZM88.414 76.8l7.898-4.876 2.915-6.765 4.353-.446 5.133-4.662V49.118s1.123 12.143.817 13.064l4.279-1.833s-3.666 3.675-4.892 3.675c-1.225 0-2.441-.307-2.441-.307s-2.135 2.14-2.441 2.14c-.306 0-2.914.53-2.914.53l-3.49 8.45-2.2-1.164-5.226 3.861-1.782-.735h-.01Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m87.801 77.72 7.899-4.875 2.915-6.764 4.353-.447 5.133-4.661V50.04s1.123 12.142.816 13.063l4.279-1.833s-3.666 3.676-4.891 3.676-2.441-.307-2.441-.307-2.135 2.14-2.442 2.14c-.306 0-2.914.53-2.914.53l-3.49 8.449-2.2-1.163-5.225 3.861-1.783-.735h-.009Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.632 36.568v3.294l2.599 1.852 2.599-2.261v3.005h2.46l.612.614 2.051-.484s-1.457 1.359-1.689 1.722c-.232.362-1.764 1.823-1.764 1.823h-2.942l-3.416 2.913 3.518-2.699 3.351.335s2.877-3.2 3.76-3.461l.686-1.6-2.692.409-1.095-1.005-1.764.335-.788-3.964-1.977 2.047.956-1.935 1.596-.958s1.28.716 1.448.716c.167 0 2.478-.288 2.478-.288l3.379 1.451 3.09-2.103 2.693.242 3.044 1.387 3.787-1.62 1.374 2.485.881.195.168-.52-1.857-4.104-4.065 2.028L34.8 34.8l-4.167.047-2.664 1.619-3.926-.884-2.21.14-1.735-.55-1.903 1.006-1.049 2.428-2.524-2.047.009.01Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.245 35.09v3.544l2.598 1.852 2.6-2.26v3.004h2.46l.612.614 2.051-.483s-1.457 1.358-1.69 1.721c-.231.363-1.763 1.824-1.763 1.824h-2.84l-3.509 2.986 3.62-2.772 3.444.344s2.96-3.285 3.861-3.554l.706-1.638-2.767.419-1.123-1.033-1.81.344-.807-4.066-2.033 2.103.975-1.982 1.643-.977s1.318.735 1.485.735c.167 0 2.543-.297 2.543-.297l3.471 1.498 3.175-2.16 2.766.243 3.128 1.423 3.889-1.665 1.41 2.55.901.195.167-.54-1.903-4.215-4.176 2.084-2.367-1.665-4.28.046-2.737 1.666-4.029-.903-2.274.15-1.782-.569-1.958 1.033-1.077 2.503-2.59-2.102h.01Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.685 35.722 2.534-4.29h3.267l3.471-1.758 2.181-1.852-2.264 1.777-3.453 2.14-3.397-.037-2.367 4.02h.028Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.224 29.945-.436-1.163.566-.959-.408-2.726.12 2.726-.603.959.557 1.274.204-.111ZM41.382 34.93l7.9-4.875 2.914-6.765 4.353-.447 5.133-4.661V7.249s1.123 12.143.817 13.064l4.279-1.833s-3.667 3.675-4.892 3.675c-1.225 0-2.441-.307-2.441-.307s-2.135 2.14-2.441 2.14c-.306 0-2.915.53-2.915.53l-3.49 8.449-2.2-1.163-5.225 3.861-1.782-.735h-.01Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.77 35.852 7.899-4.876 2.914-6.764 4.354-.447 5.132-4.662V8.171s1.123 12.142.817 13.063l4.28-1.833s-3.667 3.675-4.892 3.675c-1.226 0-2.442-.307-2.442-.307s-2.134 2.14-2.44 2.14c-.307 0-2.915.53-2.915.53l-3.49 8.45-2.2-1.164-5.226 3.862-1.782-.736h-.01Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.49 129.471-2.757.056 2.07-5.778 3.406.437-1.661-2.503 2.051-1.367.167-.856 1.977-.735s-1.958-.326-2.357-.494c-.4-.167-2.479-.53-2.479-.53l-2.45 1.638-4.455-.521 4.418.279 2.608-2.14s4.168 1.06 5.04.781l1.457.949-2.46 1.154-.352 1.442-1.652.698 1.54 3.731-2.775-.605 1.866 1.08 1.856-.093s.669-1.312.808-1.405c.139-.093 2.218-1.135 2.218-1.135l2.005-3.09 3.731.028 2.107-1.693 1.764-2.847 4.056-.763-.232-2.829.631-.651.427.344.724 4.448-4.51.577-1.022 2.633-3.49 2.279-3.118.131-2.776 2.921-1.921 1.108-1.142 1.423-2.135.223-2.218-1.442-.965 3.108v.009Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.817 130.367-2.896-.158 2.07-5.779 3.407.438-1.662-2.503 2.051-1.368.167-.856 1.977-.735s-1.958-.326-2.357-.493c-.4-.168-2.478-.53-2.478-.53l-2.358 1.581-4.576-.53 4.539.288 2.673-2.205s4.279 1.089 5.18.81l1.494.967-2.525 1.191-.362 1.48-1.699.716 1.578 3.834-2.85-.624 1.913 1.107 1.903-.093s.687-1.349.835-1.442c.149-.093 2.274-1.172 2.274-1.172l2.06-3.173 3.834.028 2.163-1.74 1.82-2.922 4.157-.781-.241-2.903.64-.67.437.353.742 4.569-4.631.595-1.05 2.708-3.582 2.336-3.202.139-2.85 2.996-1.968 1.145-1.17 1.46-2.199.233-2.274-1.479-.993 3.191.01-.009Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m59.649 122.354 4.483 2.159 2.72-1.815 3.852-.465 2.84.326-2.859-.223-4.065.148-2.804 1.926-4.195-2.037.028-.019Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m69.943 122.412.278 1.219 1.012.475 1.16 2.493-1.401-2.335-1.03-.456-.242-1.368.223-.028ZM70.648 115.954l9.264-.334 6.163 4 3.87-2.056 6.85 1.024 6.052 9.099s-5.792-10.728-6.553-11.323l4.576-.847s-5.086-1.014-6.098-.335c-1.012.679-1.866 1.61-1.866 1.61s-2.96-.596-3.22-.428c-.26.167-2.72 1.182-2.72 1.182l-7.574-5.09-1.188 2.187-6.48-.307-1.076 1.609v.009Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m69.627 115.534 9.263-.334 6.164 4 3.87-2.056 6.85 1.024 6.052 9.099s-5.792-10.728-6.553-11.323l4.576-.847s-5.087-1.014-6.098-.335c-1.012.679-1.866 1.61-1.866 1.61s-2.96-.596-3.22-.428c-.26.167-2.72 1.182-2.72 1.182l-7.574-5.09-1.188 2.187-6.48-.308-1.076 1.61v.009Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 64.387,
    height: 46.766,
    x: 169.872,
    y: 18.953,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 30.703,
    height: 26.114,
    x: 179.609,
    y: 16.555,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 17.142,
    height: 22.346,
    x: 186.877,
    y: 13.067,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 25.468,
    height: 21.006,
    x: 57.636,
    y: 51.028,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 21.402,
    height: 21.834,
    x: 60.949,
    y: 41.716,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 21.764,
    height: 20.782,
    x: 57.636,
    y: 46.033,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 27.983,
    height: 30.366,
    x: 60.448,
    y: 23.357,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 21.987,
    height: 24.504,
    x: 62.035,
    y: 30.095,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 56.412,
    height: 42.655,
    x: 47.654,
    y: 62.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 56.412,
    height: 42.655,
    x: 130.151,
    y: 24.596,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 27.482,
    height: 23.899,
    x: 139.047,
    y: 24.028,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 16.891,
    height: 20.959,
    x: 141.832,
    y: 21.301,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: 41.395,
    height: 44.416,
    x: 79.801,
    y: 42.04,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: 56.412,
    height: 42.655,
    x: 0.623,
    y: 20.391,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 41.395,
    height: 44.416,
    x: 32.77,
    y: 0.171,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 57.786,
    height: 45.818,
    x: 27.002,
    y: 97.709,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 48.199,
    height: 31.232,
    x: 61.627,
    y: 104.036,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7001_8843",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 116.64,
    x2: 116.64,
    y1: 138.089,
    y2: 78.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 69.878,
    x2: 288.506,
    y1: 27.188,
    y2: 184.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 117.03,
    x2: 116.825,
    y1: 96.954,
    y2: 110.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9DA8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 117.262,
    x2: 117.262,
    y1: 99.81,
    y2: -10.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EB0037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7A1123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackBoxmin);
export default __webpack_public_path__ + "static/media/attack-box.min.e7a8e5aa3ebbe6cecc36c00018734b69.svg";
export { ForwardRef as ReactComponent };